// extracted by mini-css-extract-plugin
export default {"operatorBannerContainer":"bx_gp","topContainer":"bx_gq","logo":"bx_B","bonusContainer":"bx_gr","couponCtaContainer":"bx_gs","nonActiveStatus":"bx_gt"};